// extracted by mini-css-extract-plugin
export default {"label":"FontPicker_label__mfT2T","select":"FontPicker_select__uT8oD","option":"FontPicker_option__uGypq"};